module.exports = __webpack_public_path__ + "img/app1.63279ca1.jpg";